<template>
  <Drawer
      :title="title"
      v-model="isBox"
      width="100%"
      :mask-closable="false"
      @on-close="FormReset()"
      class-name="drawer-default"
  >
    <div class="set-scroll-form">
      <Row :gutter="32">
        <Col :span="4">
          <Form ref="SearchForms" :model="SearchForms" :rules="SearchRules"  label-position="top">
            <Row :gutter="32">
              <Col :span="24">
                <FormItem label="项目" prop="project_id">
                  <Select class="search-select"  v-model="SearchForms.project_id"  clearable filterable  placeholder="收款项目">
                    <Option :value="item.project_id" v-for="(item,index) in projectList" :key="index">{{item.name}}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col :span="24">
                <FormItem label="采购" prop="buyer_id">
                  <Select class="search-select"  v-model="SearchForms.buyer_id"  clearable filterable  placeholder="采购信息">
                    <Option :value="item.buyer_id" v-for="(item,index) in buyerList" :key="index">{{item.title}}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col :span="24">
                <FormItem label="供应商" prop="company_id">
                  <Select class="search-select" v-model="SearchForms.company_id"  clearable filterable  placeholder="供应商">
                    <Option :value="item.company_id" v-for="(item,index) in companyList" :key="index">{{item.company}}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col :span="24">
                <FormItem label="编号" prop="sn">
                  <Input class="search-input" clearable v-model="SearchForms.sn" placeholder="支出编号" />
                </FormItem>
              </Col>
              <Col :span="24">
                <FormItem label="日期" prop="time">
                  <DatePicker class="width-100" v-model="SearchForms.time" clearable type="daterange" format="yyyy-MM-dd"  placeholder="选择日期" />
                </FormItem>
              </Col>
              <Col :span="24">
                <Button type="warning" icon="ios-search" @click="SearchSubmit()">查询记录</Button>
              </Col>
              <Col :span="24">
                <br />
                <DescriptionList class="show-description-title" title="" :col="3"  layout="vertical">
                  <Description term="发票金额：">
                    {{invoice.inv_money ?? '0.00'}}
                  </Description>
                  <Description term="选中金额：">
                    {{selectMoney}}
                  </Description>
                  <Description term="剩余金额：">
                    {{useMoney}}
                  </Description>
                </DescriptionList>
              </Col>
            </Row>
          </Form>
        </Col>
        <Col :span="20">
          <Table row-key="expend_id" ref="selection" stripe border :columns="columns" @on-selection-change="tableCheckAll"  :data="dataList" no-data-text="暂无数据记录" height="520">
            <template #sn="{ row }">
              <div class="d-width cursor text-primary" :title="row.sn" @click="showData(row.expend_id)">
                <span>{{row.sn}}</span>
              </div>
            </template>
            <template #status="{ row }">
              <Badge v-if="row.status === 1 || row.status === 2 || row.status === 3" color="blue" :text="row.status_name" />
              <Badge v-else-if="row.status === 5" color="orange" :text="row.status_name" />
              <Badge v-else-if="row.status === 7" color="green" :text="row.status_name" />
              <Poptip v-else-if="row.status === 4 || row.status === 6" trigger="hover" width="240" :word-wrap="true" title="驳回原因：" >
                <Badge color="red" :text="row.status_name" />
                <template #content>
                  <p style="white-space: normal;">时间：{{row.reject_time}}</p>
                  <p style="white-space: normal;">原因：<span class="text-danger">{{row.reject_remark}}</span></p>
                </template>
              </Poptip>
              <Badge v-else color="#999999" text="其他" />
            </template>
            <template #is_invoice="{ row }">
              <Badge v-if="row.is_invoice === 1" color="#999" :text="row.is_invoice_name" />
              <Badge v-else-if="row.is_invoice === 2" color="blue" :text="row.is_invoice_name" />
              <Badge v-else-if="row.is_invoice === 3" color="orange" :text="row.is_invoice_name" />
              <Badge v-else-if="row.is_invoice === 4" color="green" :text="row.is_invoice_name" />
              <Badge v-else color="#f00" text="未开票" />
            </template>
            <template #money="{ row }">
              <span>{{row.money}}</span>
            </template>
            <template #pay_money="{ row }">
              <span class="text-success">{{row.pay_money}}</span>
            </template>
            <template #use_inv_money="{ row }">
              <span class="text-orange">{{row.use_inv_money}}</span>
            </template>
            <template #apply_id="{ row }">
              <div class="d-width" :title="row.apply_name">
                <span>{{row.apply_name}}</span>
              </div>
            </template>
            <template #project_id="{ row }">
              <div class="d-width" :title="row.project_name">
                <span>{{row.project_name}}</span>
              </div>
            </template>
            <template #buyer_id="{ row }">
              <div class="d-width" :title="row.buyer_title">
                <span>{{row.buyer_title}}</span>
              </div>
            </template>
            <template #company_id="{ row }">
              <div class="d-width" :title="row.company">
                <span>{{row.company}}</span>
              </div>
            </template>
            <template #remark="{ row }">
              <div class="d-width" :title="row.remark">
                <span>{{row.remark ?? '-'}}</span>
              </div>
            </template>
          </Table>
          <div class="em-page">
            <div class="em-page-btn">
              <span class="text-999">选中 <em class="text-danger">{{selectCount}}</em> 条记录</span>
              <Divider type="vertical" />
              <span class="text-999 mr10">共</span>
              <strong class="text-orange">{{selectMoney}}</strong>
              <span class="text-999"> 元</span>
            </div>
          </div>
        </Col>
      </Row>
      <div class="box-drawer-footer">
        <Button class="mr10" @click="FormReset()">取消</Button>
        <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">确认发票绑定</Button>
      </div>

      <!-- 项目支出详情  -->
      <show-expend-modal v-if="is_show" ref="ShowExpendRef"></show-expend-modal>
    </div>
  </Drawer>
</template>

<script>

import {getExpendSearchList} from "@/apis/expend";
import ShowExpendModal from "@/view/expend/Show";
import {getExpendInvoiceConfig, getExpendInvoiceDetail, bindExpendInvoice} from "@/apis/invoice/expend";


export default {
  name: 'ExpendInvoiceBind',
  components: {
    ShowExpendModal
  },
  emits: ['trueHandler'],
  data () {
    return {
      title : '发票绑定支出',
      isBox : false,
      is_show : false,
      bind_invoice_id: 0,
      invoice: [],

      companyList: [],
      buyerList: [],
      projectList: [],
      SearchForms: {
        project_id: '',
        company_id: '',
        buyer_id: '',
        sn: '',
        time: []
      },
      SearchRules: {},
      dataList : [],
      selectCount  : 0,
      selectMoney  : 0,
      useMoney  : 0,
      columns: [
        {
          type: 'selection',
          width: 55,
          align: 'center',
          fixed : 'left'
        },
        {
          title: '支出编号',
          key: 'sn',
          slot: 'sn',
          width: 160
        },
        {
          title: '支出状态',
          key: 'status',
          slot: 'status',
          width: 120,
        },
        {
          title: '发票状态',
          key: 'is_invoice',
          slot: 'is_invoice',
          width: 120,
        },
        {
          title: '申请金额',
          key: 'money',
          slot: 'money',
          width: 140,
        },
        {
          title: '支出金额',
          key: 'pay_money',
          slot: 'pay_money',
          width: 140,
        },
        {
          title: '已开金额',
          key: 'use_inv_money',
          slot: 'use_inv_money',
          width: 140,
        },
        {
          title: '申请人',
          key: 'apply_id',
          slot: 'apply_id',
          width:100
        },
        {
          title: '支出项目',
          key: 'project_id',
          slot: 'project_id',
          width: 140,
        },
        {
          title: '采购信息',
          key: 'buyer_id',
          slot: 'buyer_id',
          width: 140,
        },
        {
          title: '供应商',
          key: 'company_id',
          slot: 'company_id',
          width: 140,
        },
        {
          title: '备注',
          key: 'remark',
          slot: 'remark'
        }
      ],
    }
  },
  methods: {
    tableCheckAll(){
      let that = this;
      const data = that.$refs.selection.getSelection();
      that.selectCount = data.length;
      var money = 0;
      data.forEach(item => {
        money = money + parseFloat(item.money * 100 / 100) - parseFloat(item.use_inv_money * 100 / 100)
      })
      that.selectMoney = money + parseFloat(that.invoice.use_inv_money * 100 / 100);
      that.useMoney = parseFloat(that.invoice.inv_money * 100 / 100) - that.selectMoney;
    },
    showData(id){
      let that = this;
      that.is_show = true;
      setTimeout(function(){
        that.$refs.ShowExpendRef.show(id);
      })
    },
    getList(){
      let that = this;
      that.selectMoney = that.invoice.use_inv_money;
      that.selectCount = 0;
      that.useMoney = that.invoice.inv_money - that.invoice.use_inv_money;
      const params = {
        search : that.SearchForms
      };
      getExpendSearchList(params).then(e=>{
        that.dataList = e.data;
      })
    },
    getConfig(){
      let that = this;
      getExpendInvoiceConfig().then(e=>{
        that.projectList = e.data.projectList ?? [];
        that.buyerList = e.data.buyerList ?? [];
        that.companyList = e.data.companyList ?? [];
      })
    },
    getInvoiceDetail(inv_id){
      let that = this;
      that.$store.commit('SET_LOADING' , true);
      getExpendInvoiceDetail(inv_id).then(e => {
        that.invoice = e.data;
        that.useMoney = e.data.inv_money - e.data.use_inv_money;
        that.selectMoney =  e.data.use_inv_money;
      })
    },

    /**
     功能：
     time: 2025/12/17 10:47
     **/
    show(id){
      this.isBox = true;
      this.bind_invoice_id = parseInt(id);
      this.getConfig();
      this.getInvoiceDetail(this.bind_invoice_id);
    },

    SearchSubmit(){
      let that = this;
      this.$refs['SearchForms'].validate((valid) => {
        if (valid) {
          that.getList();
        }
      })
    },
    /**
     功能：
     time: 2025/12/26 16:14
     **/
    FormSubmit(){
      let that = this;
      const data = that.$refs.selection.getSelection();
      if(data.length <= 0){
        that.$Message.error({ background: true, content:'至少选择一条记录'});
        return false;
      }
      let ids = [];
      for(var i  = 0; i < data.length; i++ ){
        ids.push(data[i].expend_id);
      }
      if(ids.length > 0){
        this.$Modal.confirm({
          title: '批量绑定发票',
          content: '此操作将批量绑定发票不可恢复, 是否继续?',
          onOk: () => {
            that.$store.commit('SET_LOADING' , true);
            bindExpendInvoice({inv_id:that.invoice.inv_id, expend_ids: ids}).then( e =>{
              that.$Message.success({ background: true,duration:3, content: e.msg });
              that.FormReset();
              that.$emit('trueHandler');
            })
          },
          onCancel: () => {}
        });
      }
    },
    /**
     功能：
     time: 2025/12/20 11:54
     **/
    FormReset(){
      this.isBox = false;
      this.title = '发票绑定支出';
      this.$refs['SearchForms'].resetFields();
      this.SearchForms = {
        project_id: '',
        company_id: '',
        buyer_id: '',
        sn: '',
        time: []
      };
      this.selectCount = 0;
      this.selectMoney = 0;
      this.useMoney = 0;
      this.dataList = [];
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
